/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { oneOfType, object, array, string } from 'prop-types';
import { NavLink } from 'react-router-dom';

import { createUrl } from 'utils/urlHelper';

/**
 * This is the MapWPCategories component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
const MapWPCategories = ({ categories, className, activeClassName }) => {
  let items = categories;

  if (typeof categories === 'object') {
    items = [];

    Object.keys(categories).map(key => {
      items.push({
        ...categories[key],
      });
    });
  }

  return items.map(({ slug, name }) => (
    <li key={slug} className={className}>
      <NavLink
        to={createUrl('blogCategory', slug)}
        activeClassName={activeClassName}
      >
        {name}
      </NavLink>
    </li>
  ));
};

/**
 * Declare expected property types.
 *
 * @type {Object}
 */
MapWPCategories.propTypes = {
  categories: oneOfType([array, object]).isRequired,
  className: string,
  activeClassName: string,
};

MapWPCategories.defaultProps = {
  className: null,
  activeClassName: null,
};

export default MapWPCategories;
